import type { PropsWithChildren, ReactNode } from 'react';

import {
  Card as BackstageCard,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
} from '@backstage/ui';
import clsx from 'clsx';

import classes from './Card.module.css';

type Props = PropsWithChildren<{
  className?: string;
  footer?: ReactNode;
  headerActions?: ReactNode;
  title?: ReactNode;
}>;

export const Card = ({
  children,
  className,
  footer,
  headerActions,
  title,
}: Props) => (
  <BackstageCard className={clsx(classes.root, className)}>
    {(!!title || !!headerActions) && (
      <CardHeader>
        <div className={classes.header}>
          {!!title && (
            <Text as="h2" className={classes.title} variant="title-x-small" weight="bold">
              {title}
            </Text>
          )}
          {!!headerActions && (
            <div className={classes.headerActions}>{headerActions}</div>
          )}
        </div>
      </CardHeader>
    )}
    <CardBody>{children}</CardBody>
    {!!footer && (
      <CardFooter className={classes.footer}>{footer}</CardFooter>
    )}
  </BackstageCard>
);
